<template>
  <div>
      <vs-popup title="Feedback" fullscreen :active.sync="show">
        <div class="iframe-container" v-if="organizationIds">
          <iframe
            :src="
              'https://gala.talentprint.com/users/manage_raters' +
              autoLoginToken
            "
            :key="userProgress"
            class="w-full h-full border-0"
            title="Feedback"
          >
          </iframe>
        </div>
        <div class="iframe-container" v-else>
          <iframe
            :src="
              'https://lab.getboarded.com/users/manage_raters' +
              localPersonalityData.personalityYoulabToken
            "
            :key="userProgress"
            class="w-full h-full border-0"
            title="Feedback"
          >
          </iframe>
        </div>
      </vs-popup>
      <vs-popup
        title="Career Lab Report"
        fullscreen
        :active.sync="CareerLabReport"
      >
        <div class="iframe-container" v-if="organizationIds">
          <iframe
            :src="'https://gala.talentprint.com/profiles/view' + autoLoginToken"
            class="w-full h-full border-0"
            id="reportReload"
            :key="userProgress"
            title="Career Lab Report"
          >
          </iframe>
        </div>
        <div class="iframe-container" v-else>
          <iframe
            :src="
              'https://lab.getboarded.com/profiles/view' +
              localPersonalityData.personalityYoulabToken
            "
            :key="userProgress"
            id="reportReload"
            class="w-full h-full border-0"
            title="Personality Report "
          >
          </iframe>
        </div>
      </vs-popup>
      <div class="mb-base">
        <div class="flex justify-between flex-wrap mb-1">
          <div class="w-full lg:w-2/3 xl:w-2/3">
            <iframe
              v-if="organizationIds"
              :src="'https://gala.talentprint.com/' + autoLoginToken"
              class="w-full h-full border-0"
              style="display: none"
            >
            </iframe>
            <iframe
              v-else
              :src="
                'https://lab.getboarded.com/' +
                localPersonalityData.personalityYoulabToken
              "
              class="w-full h-full border-0"
              style="display: none"
            >
            </iframe>
            <vs-row>
              <h3 class="float-left mr-4">
                {{ $t("editor.personality.title") }}
              </h3>
              <vx-tooltip
                v-if="saveInProgress"
                class="float-left mr-base"
                text="Saving to cloud..."
              >
                <feather-icon
                  icon="CloudIcon"
                  class="save-in-progress-status-icon"
                  svgClasses="text-success"
                /></vx-tooltip>
              <vx-tooltip
                v-else
                class="float-left mr-base"
                text="Saved to cloud"
              ><feather-icon
                icon="CloudIcon"
                class="save-in-progress-status-icon"
              /></vx-tooltip>

              <!-- Personality Tour -->
              <v-tour
                name="personalityTour"
                :steps="personalityTourSteps"
                :callbacks="personalityTourCallbacks"
              ></v-tour>

              <vs-row class="personality-options" style="width: auto">
                <!--- Reset All --->
                <vx-tooltip class="mr-4" text="Reset All" position="bottom"
                ><vs-button
                  id="pi-step-0"
                  :disabled="
                      localPersonalityData.personalityTraitsGala &&
                      !localPersonalityData.personalityTraitsGala.length > 0
                    "
                  @click.stop="resetPersonalityTraits()"
                  size="small"
                  color="primary"
                  type="flat"
                  icon-pack="material-icons"
                  icon="settings_backup_restore"
                ></vs-button
                ></vx-tooltip>
                <!--- Only Reset Priority --->
                <vx-tooltip
                  class="mr-4"
                  text="Only Reset Priority"
                  position="bottom"
                ><vs-button
                  id="pi-step-1"
                  :disabled="!priorityStatus"
                  @click.stop="onlyResetPriorityPersonalityTraits()"
                  size="small"
                  color="primary"
                  type="flat"
                  icon-pack="material-icons"
                  icon="low_priority"
                ></vs-button
                ></vx-tooltip>
                <!--                {{autoLoginToken}}-->
                <div v-if="organizationIds">
                  <vx-tooltip
                    class="mr-4"
                    v-if="autoLoginToken && isUserLoggedIn"
                    text="Get Feedback"
                    position="bottom"
                  ><vs-button
                    id="pi-step-2"
                    size="small"
                    color="primary"
                    type="flat"
                    @click="feedback"
                    icon-pack="material-icons"
                    icon="supervisor_account"
                    :disabled="
                        !(
                          this.$store.state.boards.userBoardData.progress > 0 &&
                          isUserLoggedIn
                        )
                      "
                  ></vs-button
                  ></vx-tooltip>
                </div>
                <div v-else>
                  <vx-tooltip
                    class="mr-4"
                    v-if="
                      localPersonalityData.personalityYoulabToken &&
                      isUserLoggedIn
                    "
                    text="Get Feedback"
                    position="bottom"
                  ><vs-button
                    id="pi-step-2"
                    size="small"
                    color="primary"
                    type="flat"
                    @click="feedback"
                    icon-pack="material-icons"
                    icon="supervisor_account"
                    :disabled="
                        !(
                          localPersonalityData.personalityYoulabToken &&
                          localPersonalityData.personalityYoulabProgress > 0 &&
                          isUserLoggedIn
                        )
                      "
                  ></vs-button
                  ></vx-tooltip>
                </div>

                <!--                {{localPersonalityData.personalityYoulabToken}}-->
                <!--                {{localPersonalityData.isUserLoggedIn}}-->
                <div v-if="organizationIds">
                  <vx-tooltip
                    class="mr-4"
                    :text="
                      this.$store.state.boards.userBoardData.progress === 2
                        ? 'Talent Discovery'
                        : 'Report will be activated after a minimum 4 feedbacks are received\n' +
                          '\n'
                    "
                    position="bottom"
                    v-if="autoLoginToken && isUserLoggedIn"
                  >
                    <vs-button
                      id="pi-step-3"
                      size="small"
                      @click="personalityReport()"
                      color="primary"
                      type="flat"
                      icon-pack="material-icons"
                      icon="layers"
                      :disabled="
                        !(
                          this.$store.state.boards.userBoardData.progress ===
                            2 && isUserLoggedIn
                        )
                      "
                    ></vs-button>
                  </vx-tooltip>
                </div>
                <div v-else>
                  <vx-tooltip
                    class="mr-4"
                    :text="
                      localPersonalityData.personalityYoulabProgress === 2
                        ? 'Personality'
                        : 'Report will be activated after a minimum 4 feedbacks are received\n' +
                          '\n'
                    "
                    position="bottom"
                    v-if="
                      localPersonalityData.personalityYoulabToken &&
                      isUserLoggedIn
                    "
                  >
                    <vs-button
                      id="pi-step-3"
                      size="small"
                      @click="personalityReport()"
                      color="primary"
                      type="flat"
                      icon-pack="material-icons"
                      icon="layers"
                      :disabled="
                        !(
                          localPersonalityData.personalityYoulabProgress ===
                            2 && isUserLoggedIn
                        )
                      "
                    ></vs-button>
                  </vx-tooltip>
                </div>
                <!--                <vx-tooltip-->
                <!--                  class="mr-4"-->
                <!--                  text="Career Lab "-->
                <!--                  position="bottom"-->
                <!--                >-->
                <!--                <vs-button-->
                <!--                  id="pi-step-3"-->
                <!--                  size="small"-->
                <!--                  @click="personalitySync()"-->
                <!--                  color="primary"-->
                <!--                  type="flat"-->
                <!--                  icon-pack="material-icons"-->
                <!--                  icon="layers"-->
                <!--                ></vs-button-->
                <!--                >-->
                <!--                </vx-tooltip>-->
              </vs-row>
            </vs-row>
          </div>

        </div>
        <!-- <p v-if="!isUserLoggedIn" class="text-danger">
            You are not authenticated. Please login to save your data.
          </p>
          <p v-else-if="internetConnectionStatus">
            Internet Connection Active. Keep editing and your data gets auto-saved.
          </p>
          <p v-else class="text-danger">
            No Internet Connection. Please connect to Internet to save your data.
          </p> -->
        <p v-if="!isUserLoggedIn">
          <span v-if="organizationSlug === 'default'">
            {{ $t("editor.utils.notAuthenticated.youAreNotAuthenticated") }}
            <router-link :to="{ name: 'editor-about' }">{{
                $t("editor.utils.notAuthenticated.login")
              }}</router-link>
            {{ $t("editor.utils.notAuthenticated.toSaveYourData") }}
          </span>
          <span v-else>
            {{ $t("editor.utils.notAuthenticated.youAreNotAuthenticated") }}
            <router-link :to="{ name: 'editor-about-custom' }">{{
                $t("editor.utils.notAuthenticated.login")
              }}</router-link>
            {{ $t("editor.utils.notAuthenticated.toSaveYourData") }}
          </span>
        </p>
      </div>
      <div class="mb-base d-character-types">
        <div class="vx-row">
          <div
            v-for="(ccg, index) in characterCardsGala"
            :key="index"
            class="vx-col w-1/6 items-center"
            @mouseover="toggleCharacterType(ccg.slug, true)"
            @mouseleave="toggleCharacterType(ccg.slug, false)"
          >
            <div class="cursor-pointer">
              <div
                :style="{ border: ccg.border, background: ccg.background }"
                style="border-radius: 6px 6px 0px 0px"
              >
                {{ ccg.title }}
              </div>
              <div
                :style="{ borderLeft: ccg.border, borderRight: ccg.border, background: characterClass[ccg.slug] ? ccg.background : 'transparent' }"
                style="`height: 100px; border-left: ${ccg.border}; border-right: ${ccg.border}`"
              >
                <img :src="ccg.image" :alt="ccg.title" />
              </div>
              <div
                :style="{ border: ccg.border, background: ccg.background }"
                style="border-radius: 0px 0px 6px 6px"
              >
                {{ getCharacterTypeCount(ccg) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-form">
        <h5 v-if="!best6Set" class="mb-2 text-dark">
          {{ $t("editor.personality.chooseYourTop6Strengths.p1") }}
          <span class="text-success"
          ><b>{{
              $t("editor.personality.chooseYourTop6Strengths.p2")
            }}</b></span
          >
          {{ $t("editor.personality.chooseYourTop6Strengths.p3") }}
        </h5>
        <div v-else class="mb-3">
          <h5 class="mb-2 text-dark">
            {{ $t("editor.personality.characteristicsThatBestDescribeYou.p1") }}
            <span class="text-success"
            ><b>{{
                $t("editor.personality.characteristicsThatBestDescribeYou.p2")
              }}</b></span
            >
            {{ $t("editor.personality.characteristicsThatBestDescribeYou.p3") }}
          </h5>
          <!-- Assign Priority Number -->
          <vs-row
            v-if="personalityData && Object.keys(personalityData).length"
            class="personality-row mb-2"
          >
            <vs-col
              v-for="(p, index) in localPersonalityData.personalityTraitsGala"
              :key="index"
              vs-w="4"
              vs-xs="12"
            >
              <div v-if="index < 6">
                <div class="px-1 mb-2">
                  <vx-tooltip
                    :text="getPersonalityTraitById(p.id).description"
                    position="right"
                  >
                    <div @click.stop="pushPersonality(p.id)"
                         @mouseover="toggleCharacterClass(getPersonalityTraitById(p.id).characterType, true)"
                         @mouseleave="toggleCharacterClass(getPersonalityTraitById(p.id).characterType, false)"
                    >
                      <vs-row
                        :class="`personality-unit ${p.id}`"
                        :style="[
                          isCharacterTypeHovered(
                            getPersonalityTraitById(p.id).characterType
                          )
                            ? {
                                background: getPersonalityTraitById(p.id)
                                  .background,
                              }
                            : { background: bgOfBest, border: borderOfBest },
                          personalityTraitSelected(p.id) ? {} : {},
                        ]"
                        vs-align="center"
                        vs-type="flex"
                        vs-justify="center"
                      >
                        <vs-col
                          vs-w="3"
                          vs-type="flex"
                          vs-justify="center"
                          vs-align="center"
                        >
                          <span
                            class="
                              p-3
                              inline-flex
                              rounded-full
                              feather-icon
                              select-none
                              relative
                              text-primary
                            "
                          >
                            <img
                              :src="getPersonalityTraitById(p.id).pngIcon"
                              :alt="getPersonalityTraitById(p.id).title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                        </vs-col>
                        <vs-col
                          vs-w="7"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div class="items-left">
                            <div class="personality-title">
                              {{ $t(getPersonalityTraitById(p.id).title) }}
                            </div>
                          </div>
                        </vs-col>
                        <vs-col
                          vs-w="2"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div v-if="p.priorityNumber" class="items-center">
                            <div class="personality-order">
                              {{ p.priorityNumber }}
                            </div>
                          </div>
                        </vs-col>
                      </vs-row>
                    </div>
                  </vx-tooltip>
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <div v-if="best6Set">
          <h5 v-if="!most6Set" class="mb-2 text-dark">
            {{ $t("editor.personality.choose6MoreStrengths.p1") }}
            <span class="text-primary"
            ><b>{{
                $t("editor.personality.choose6MoreStrengths.p2")
              }}</b></span
            >
            {{ $t("editor.personality.choose6MoreStrengths.p3") }}
          </h5>
          <div v-else class="mb-3">
            <h5 class="mb-2 text-dark">
              {{
                $t("editor.personality.characteristicsThatMostDescribeYou.p1")
              }}
              <span class="text-primary"
              ><b>{{
                  $t("editor.personality.characteristicsThatMostDescribeYou.p2")
                }}</b></span
              >
              {{
                $t("editor.personality.characteristicsThatMostDescribeYou.p3")
              }}
            </h5>
            <!--Assign Priority Number -->
            <vs-row
              v-if="personalityData && Object.keys(personalityData).length"
              class="personality-row mb-2"
            >
              <vs-col
                v-for="(p, index) in localPersonalityData.personalityTraitsGala"
                :key="index"
                vs-w="4"
                vs-xs="12"
              >
                <div v-if="index >= 6 && index < 12">
                  <div class="px-1 mb-2">
                    <vx-tooltip
                      :text="getPersonalityTraitById(p.id).description"
                      position="right"
                    >
                      <div
                        @click.stop="pushPersonality(p.id)"
                        @mouseover="toggleCharacterClass(getPersonalityTraitById(p.id).characterType, true)"
                        @mouseleave="toggleCharacterClass(getPersonalityTraitById(p.id).characterType, false)"
                      >
                        <vs-row
                          :key="isCharacterTypeHovered(p.characterType)"
                          :class="`personality-unit--most ${p.id}`"
                          :style="[
                            isCharacterTypeHovered(
                              getPersonalityTraitById(p.id).characterType
                            )
                              ? {
                                  background: getPersonalityTraitById(p.id)
                                    .background,
                                }
                              : { background: bgOfMost, border: borderOfMost },
                            personalityTraitSelected(p.id) ? {} : {},
                          ]"
                          vs-align="center"
                          vs-type="flex"
                          vs-justify="center"
                        >
                          <vs-col
                            vs-w="3"
                            vs-type="flex"
                            vs-justify="center"
                            vs-align="center"
                          >
                            <span
                              class="
                                p-3
                                inline-flex
                                rounded-full
                                feather-icon
                                select-none
                                relative
                                text-primary
                              "
                            >
                              <img
                                :src="getPersonalityTraitById(p.id).pngIcon"
                                :alt="getPersonalityTraitById(p.id).title"
                                width="24px"
                                height="24px"
                              />
                            </span>
                          </vs-col>
                          <vs-col
                            vs-w="7"
                            vs-type="flex"
                            vs-justify="left"
                            vs-align="left"
                          >
                            <div class="items-left">
                              <div class="personality-title">
                                {{ getPersonalityTraitById(p.id).title }}
                              </div>
                            </div>
                          </vs-col>
                          <vs-col
                            vs-w="2"
                            vs-type="flex"
                            vs-justify="left"
                            vs-align="left"
                          >
                            <div v-if="p.priorityNumber" class="items-center">
                              <div class="personality-order">
                                {{ p.priorityNumber }}
                              </div>
                            </div>
                          </vs-col>
                        </vs-row>
                      </div>
                    </vx-tooltip>
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </div>
        <div class="mb-base">
          <h5 v-if="most6Set" class="mb-2 text-dark">
            {{
              $t("editor.personality.characteristicsThatLeastDescribeYou.p1")
            }}
            <span class="text-warning"
            ><b>{{
                $t("editor.personality.characteristicsThatLeastDescribeYou.p2")
              }}</b></span
            >
            {{
              $t("editor.personality.characteristicsThatLeastDescribeYou.p3")
            }}
          </h5>
          <!-- Assign Priority Number -->
          <vs-row
            v-if="personalityData && Object.keys(personalityData).length"
            class="personality-row mb-4"
          >
            <vs-col
              v-for="(p, index) in sortedPersonalityData"
              :key="index"
              vs-w="4"
              vs-xs="12"
            >
              <div v-if="index < 6 && !best6Set">
                <div class="px-1 mb-2">
                  <vx-tooltip
                    :text="getPersonalityTraitById(p.id).description"
                    position="right"
                  >
                    <div
                      @click.stop="pushPersonality(p.id, index)"
                      @mouseover="toggleCharacterClass(p.characterType, true)"
                      @mouseleave="toggleCharacterClass(p.characterType, false)"
                    >
                      <vs-row
                        :key="isCharacterTypeHovered(p.characterType)"
                        :class="`personality-unit cursor-pointer ${p.id}`"
                        :style="[
                          isCharacterTypeHovered(p.characterType)
                            ? {
                                background: getPersonalityTraitById(p.id)
                                  .background,
                              }
                            : {},
                          personalityTraitSelected(p.id)
                            ? { background: bgOfBest, border: borderOfBest }
                            : {},
                        ]"
                        vs-align="center"
                        vs-type="flex"
                        vs-justify="center"
                      >
                        <vs-col
                          vs-w="3"
                          vs-type="flex"
                          vs-justify="center"
                          vs-align="center"
                        >
                          <span
                            class="
                              p-3
                              inline-flex
                              rounded-full
                              feather-icon
                              select-none
                              relative
                              text-primary
                            "
                          >
                            <img
                              :src="p.pngIcon"
                              :alt="p.title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                        </vs-col>
                        <vs-col
                          vs-w="9"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div class="items-left">
                            <!-- recheck -->
                            <div class="personality-title">
                              {{ getPersonalityTraitById(p.id).title }}
                            </div>
                          </div>
                        </vs-col>
                        <!-- <vs-col
                            vs-w="2"
                            vs-type="flex"
                            vs-justify="left"
                            vs-align="left"
                          >
                            <div v-if="personalityTraitSelected(p.id)" class="items-center">
                              <div class="personality-order">{{ parseInt(index) + 1 }}</div>
                            </div>
                          </vs-col> -->
                      </vs-row>
                    </div>
                  </vx-tooltip>
                </div>
              </div>
              <div v-else-if="index >= 6 && index < 12 && !most6Set">
                <div class="px-1 mb-2">
                  <vx-tooltip
                    :text="getPersonalityTraitById(p.id).description"
                    position="right"
                  >
                    <div @click.stop="pushPersonality(p.id, index)"
                         @mouseover="toggleCharacterClass(p.characterType, true)"
                         @mouseleave="toggleCharacterClass(p.characterType, false)">
                      <vs-row
                        :key="isCharacterTypeHovered(p.characterType)"
                        :class="`personality-unit cursor-pointer ${p.id}`"
                        :style="[
                          isCharacterTypeHovered(p.characterType)
                            ? {
                                background: getPersonalityTraitById(p.id)
                                  .background,
                              }
                            : {},
                          personalityTraitSelected(p.id)
                            ? { background: bgOfMost, border: borderOfMost }
                            : {},
                        ]"
                        vs-align="center"
                        vs-type="flex"
                        vs-justify="center"
                      >
                        <vs-col
                          vs-w="3"
                          vs-type="flex"
                          vs-justify="center"
                          vs-align="center"
                        >
                          <span
                            class="
                              p-3
                              inline-flex
                              rounded-full
                              feather-icon
                              select-none
                              relative
                              text-primary
                            "
                          >
                            <img
                              :src="p.pngIcon"
                              :alt="p.title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                        </vs-col>
                        <vs-col
                          vs-w="9"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div class="items-left">
                            <div class="personality-title">
                              {{ getPersonalityTraitById(p.id).title }}
                            </div>
                          </div>
                        </vs-col>
                        <!-- <vs-col
                            vs-w="2"
                            vs-type="flex"
                            vs-justify="left"
                            vs-align="left"
                          >
                            <div v-if="personalityTraitSelected(p.id)" class="items-center">
                              <div class="personality-order">{{ parseInt(index) + 1 }}</div>
                            </div>
                          </vs-col> -->
                      </vs-row>
                    </div>
                  </vx-tooltip>
                </div>
              </div>
              <div v-else-if="index >= 12">
                <div class="px-1 mb-2">
                  <vx-tooltip
                    :text="getPersonalityTraitById(p.id).description"
                    position="right"
                  >
                    <div @click.stop="pushPersonality(p.id, index)"
                         @mouseover="toggleCharacterClass(p.characterType, true)"
                         @mouseleave="toggleCharacterClass(p.characterType, false)">
                      <vs-row
                        :key="isCharacterTypeHovered(p.characterType)"
                        :class="`personality-unit cursor-pointer ${p.id}`"
                        :style="[
                          isCharacterTypeHovered(p.characterType)
                            ? {
                                background: getPersonalityTraitById(p.id)
                                  .background,
                              }
                            : {},
                          personalityTraitSelected(p.id)
                            ? {}
                            : {},
                        ]"
                        vs-align="center"
                        vs-type="flex"
                        vs-justify="center"
                      >
                        <vs-col
                          vs-w="3"
                          vs-type="flex"
                          vs-justify="center"
                          vs-align="center"
                        >
                          <span
                            class="
                              p-3
                              inline-flex
                              rounded-full
                              feather-icon
                              select-none
                              relative
                              text-primary
                            "
                          >
                            <img
                              :src="p.pngIcon"
                              :alt="p.title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                        </vs-col>
                        <vs-col
                          vs-w="7"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div class="items-left">
                            <div class="personality-title">
                              {{ getPersonalityTraitById(p.id).title }}
                            </div>
                          </div>
                        </vs-col>
                        <vs-col
                          vs-w="2"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div
                            v-if="getCurrentPriorityNumber(p.id)"
                            class="items-center"
                          >
                            <div class="personality-order">
                              {{ getCurrentPriorityNumber(p.id) }}
                            </div>
                          </div>
                        </vs-col>
                      </vs-row>
                    </div>
                  </vx-tooltip>
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
<!--        <div class="vx-row">-->
<!--          <div class="vx-col w-full md:w-1/2">-->
<!--            <vs-row class="mb-3">-->
<!--              <label>{{-->
<!--                  $t("editor.personality.keepBuildingYourPersonalBrand")-->
<!--                }}</label>-->
<!--            </vs-row>-->
<!--            <vs-row class="mb-2">-->
<!--              <vs-radio-->
<!--                class="mr-3"-->
<!--                name="Dont Broadcast my personality"-->
<!--                v-model="localPersonalityData.broadcastPersonalityGala"-->
<!--                vs-value="dont-broadcast-my-personality"-->
<!--                @input="saveField('saveBroadcastPersonalityGala')"-->
<!--                :disabled="disableInputField"-->
<!--              >-->
<!--                <span-->
<!--                  class="text-personality-style"-->
<!--                  :class="{-->
<!--                    'broadcast-personality-selected':-->
<!--                      localPersonalityData.broadcastPersonalityGala ===-->
<!--                      'dont-broadcast-my-personality',-->
<!--                  }"-->
<!--                >-->
<!--                  {{ $t("editor.personality.dontBroadcastMyPersonality") }}-->
<!--                </span>-->
<!--              </vs-radio>-->
<!--            </vs-row>-->
<!--            <vs-row class="mb-2">-->
<!--              <vs-radio-->
<!--                class="mr-3"-->
<!--                name="Show personality statements"-->
<!--                v-model="localPersonalityData.broadcastPersonalityGala"-->
<!--                vs-value="show-personality-statements"-->
<!--                @input="saveField('saveBroadcastPersonalityGala')"-->
<!--                :disabled="disableInputField"-->
<!--              >-->
<!--                <span-->
<!--                  class="text-personality-style"-->
<!--                  :class="{-->
<!--                    'broadcast-personality-selected':-->
<!--                      localPersonalityData.broadcastPersonalityGala ===-->
<!--                      'show-personality-statements',-->
<!--                  }"-->
<!--                >-->
<!--                  {{ $t("editor.personality.statements") }}-->
<!--                </span>-->
<!--              </vs-radio>-->
<!--              <vs-radio-->
<!--                class="mr-3"-->
<!--                name="Show cloud tag"-->
<!--                v-model="localPersonalityData.broadcastPersonalityGala"-->
<!--                vs-value="show-cloud-tag"-->
<!--                @input="saveField('saveBroadcastPersonalityGala')"-->
<!--                :disabled="disableInputField"-->
<!--              >-->
<!--                <span-->
<!--                  class="text-personality-style"-->
<!--                  :class="{-->
<!--                    'broadcast-personality-selected':-->
<!--                      localPersonalityData.broadcastPersonalityGala ===-->
<!--                      'show-cloud-tag',-->
<!--                  }"-->
<!--                >-->
<!--                  {{ $t("editor.personality.cloudTags") }}-->
<!--                </span>-->
<!--              </vs-radio>-->
<!--              <vs-radio-->
<!--                class="mr-3"-->
<!--                name="Show icons"-->
<!--                v-model="localPersonalityData.broadcastPersonalityGala"-->
<!--                vs-value="show-icons"-->
<!--                @input="saveField('saveBroadcastPersonalityGala')"-->
<!--                :disabled="disableInputField"-->
<!--              >-->
<!--                <span-->
<!--                  class="text-personality-style"-->
<!--                  :class="{-->
<!--                    'broadcast-personality-selected':-->
<!--                      localPersonalityData.broadcastPersonalityGala ===-->
<!--                      'show-icons',-->
<!--                  }"-->
<!--                >-->
<!--                  {{ $t("editor.personality.icons") }}-->
<!--                </span>-->
<!--              </vs-radio>-->
<!--            </vs-row>-->
<!--          </div>-->
<!--          <div class="vx-col w-full md:w-1/2">-->
<!--            <label class="flex items-center">-->
<!--              {{ $t("editor.personality.personalityStatements") }}-->
<!--              <vx-tooltip-->
<!--                text="These are some guidelines on how to communicate your personality type. These are editable to give you freedom to express your own version of it."-->
<!--                position="top"-->
<!--                style="display: flex; align-items: baseline"-->
<!--                class="items-center ml-2"-->
<!--              >-->
<!--                <feather-icon icon="InfoIcon" class="w-4 h-4" />-->
<!--              </vx-tooltip>-->
<!--            </label>-->
<!--            <vs-textarea-->
<!--              class="w-full"-->
<!--              height="100px"-->
<!--              name="Personality Statements"-->
<!--              :disabled="disableInputField"-->
<!--              v-model="localPersonalityData.personalityStatementsGala"-->
<!--              @input="saveField('savePersonalityStatementsGala')"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
      </div>

  </div>
</template>

<script>

import constants from "@/constants";
import {
  successNotifyService, failureNotifyService,
} from "@/services/errors.service.js";
import { saveInputFieldService } from "@/services/editor/personality.service.js";

// import personalityData from "@/assets/data/personality.js";
// import _ from "lodash";
import characterCardsGala from "@/assets/data/character-cards-gala";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {  VuePerfectScrollbar },
  name: "EditorPersonality",
  props: ["personalityData"],
  data() {
    return {
      localData: {},
      localPersonalityData: {
        personalityTraitsGala: [],
      },
      personalityId: [],
      organizationIds: "",
      idDataAll:[],
      idBestData:[],
      idMostData:[],
      idLeastData:[],
      mergeData:[],
      personalityYoulabToken: null,
      answers: [],
      constants,
      show: false,
      priorityStatus: false,
      youlabIdcheck: false,
      CareerLabReport: false,
      aboutSectionCheck: false,
      youlbTokenCheck: false,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 40,
        wheelSpeed: 0.6,
      },
      // personalityData: this.shufflePersonalityData(personalityData),
      sortedPersonalityData: this.personalityData,
      personalityTourSteps: [
        {
          target: "#pi-step-0",
          header: {
            title: "Reset All",
          },
          content: `Clear all your characteristics and make a self assessment again.`,
        },
        {
          target: "#pi-step-1",
          header: {
            title: "Only Reset Priority",
          },
          content: `Reset Development Priority and add behaviours that you wish to develop.`,
        },
        {
          target: "#pi-step-2",
          header: {
            title: "Get Feedback",
          },
          content: `Gather positive feedback from peers to validate your personality type. A quick 2 step form to assess how people see your personality.`,
        },
        {
          target: "#pi-step-3",
          header: {
            title: "Career Lab",
          },
          content: `Competency Report to discover your hidden strengths and blind spots.`,
        },
      ],
      personalityTourCallbacks: {
        onPreviousStep: this.personalityTourPreviousStep,
        onNextStep: this.personalityTourNextStep,
        onFinish: this.personalityTourFinish,
        onSkip: this.personalityTourSkip,
      },
      characterCardsGala,
      characterType: {},
      characterClass: {},
      bgOfBest: "rgba(96, 191, 25, 0.06)",
      borderOfBest: "1px solid #60bf19",
      bgOfMost: "rgba(242, 147, 0, 0.06)",
      borderOfMost: "1px solid #f29300",
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    saveInProgress() {
      return this.$store.state.editor.saveInProgress;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    personality() {
      return this.$store.state.editor.personality;
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    internetConnectionStatus() {
      return this.$store.state.users.internetConnectionStatus;
    },
    disableInputField() {
      return !this.isUserLoggedIn || !this.internetConnectionStatus;
    },
    best6Set() {
      if (this.localPersonalityData.personalityTraitsGala) {
        if (this.localPersonalityData.personalityTraitsGala.length >= 6) {
          return true;
        }
      }
      return false;
    },
    most6Set() {
      if (this.localPersonalityData.personalityTraitsGala) {
        if (this.localPersonalityData.personalityTraitsGala.length >= 12) {
          // this.startPersonalityTour();
          return true;
        }
      }
      return false;
    },
    userProgress() {
      return this.$store.state.boards.userBoardData.progress;
    },
    autoLoginToken() {
      return this.$store.state.boards.userBoardData.youlabToken;
    },
    activateFeedback() {
      return this.autoLoginToken && this.userProgress >= 1;
    },
    activateCompetency() {
      return this.autoLoginToken && this.userProgress >= 2;
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
  },
  watch: {
    usersData(newVal) {
      if (newVal) {
        //// console.log(newVal);
        this.localData = JSON.parse(JSON.stringify(newVal));
      }
    },
    personality(newVal) {
      if (newVal) {
        // // console.log(newVal);
        this.localPersonalityData = JSON.parse(JSON.stringify(newVal));
      }
    },
    localPersonalityData(newVal) {
      if (newVal) {
        // // console.log(newVal);
        this.sortedPersonalityData = this.sortPersonalityData();
        // // console.log(this.sortedPersonalityData);
      }
    },

    // most6Set(newVal) {
    //   console.log(newVal, 'most6set');
    //   if(newVal === true) {
    //     console.log('1234');
    //     this.startPersonalityTour();
    //   }
    // },
    // $tours(newVal) {
    //   console.log(newVal, 'tour');
    //   if(this.most6Set) {
    //     this.startPersonalityTour();
    //   }
    // }
  },
  methods: {
    startPersonalityTour() {
      console.log("start tour #######");
      if (
        this.$route.name.includes("editor-personality") &&
        localStorage.getItem("personalityTour") !== "finished" &&
        localStorage.getItem("personalityTour") !== "skipped"
      ) {
        // console.log(this.$tours);
        if (this.$tours["personalityTour"]) {
          this.$tours["personalityTour"].start();
        }
      }
    },
    personalityTourPreviousStep(currentStep) {},
    personalityTourNextStep(currentStep) {},
    personalityTourFinish(currentStep) {
      localStorage.setItem("personalityTour", "finished");
    },
    personalityTourSkip(currentStep) {
      localStorage.setItem("personalityTour", "skipped");
    },
    feedback() {
      this.show = true;
    },
    shufflePersonalityData(array) {
      let currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
    resetPersonalityTraits() {
      this.localPersonalityData.personalityTraitsGala = [];
      this.personalityId=[];
      this.idDataAll=[];
      this.idBestData=[];
      this.idMostData=[];
      this.idLeastData=[];
      this.mergeData=[];
      this.answers=[];
      this.priorityStatus = false;
      this.saveField("savePersonalityTraitsGala");
      this.localPersonalityData.personalityStatementsGala = null;
      this.saveField("savePersonalityStatementsGala");
    },
    onlyResetPriorityPersonalityTraits() {
      if (this.localPersonalityData.personalityTraitsGala) {
        this.localPersonalityData.personalityTraitsGala.forEach((pt) => {
          delete pt.priorityNumber;
          this.priorityStatus = false;
        });

        this.saveField("savePersonalityTraitsGala");
      } else {
        return;
      }
    },
    personalityReport() {
      this.CareerLabReport = true;
      document.getElementById('reportReload').src = document.getElementById('reportReload').src
    },
    getPersonalityTraitById(id) {
      const p = this.personalityData.find((pd) => pd.id === id);
      return p;
    },
    getCurrentPriorityNumber(id) {
      if (this.localPersonalityData.personalityTraitsGala) {
        let cpObj = this.localPersonalityData.personalityTraitsGala.find(
          (pt) => pt.id === id
        );
        if (cpObj) {
          this.priorityStatus = true;
          return cpObj.priorityNumber;
        }
        return null;
      }
      return null;
    },
    getNextPriorityNumber() {
      let pn = 0;
      this.localPersonalityData.personalityTraitsGala.forEach((p) => {
        if (p.priorityNumber > 0) pn = pn + 1;
        this.priorityStatus = true;
      });
      return pn + 1;
    },
    sortPersonalityData() {
      // if(this.most6Set) return;

      let allPData = this.personalityData;
      let selectedPData = this.localPersonalityData.personalityTraitsGala;

      if (!Object.keys(allPData).length) return [];
      allPData = JSON.parse(JSON.stringify(allPData));

      if (!this.isUserLoggedIn) return allPData;

      if (!selectedPData || !selectedPData.length) return allPData;
      selectedPData = JSON.parse(JSON.stringify(selectedPData));

      let sortedData = [];
      let unSelectedData = [];

      selectedPData.forEach((sp) => {
        let spo = Object.keys(allPData).find((p) => {
          return allPData[p].id === sp.id;
        });
        sortedData.push(allPData[spo]);
      });

      let arrOfIds = [];
      selectedPData.forEach((sd) => {
        arrOfIds.push(sd.id);
      });

      Object.keys(allPData).forEach((ap) => {
        if (!arrOfIds.includes(allPData[ap].id)) {
          // // console.log(allPData[ap]);
          unSelectedData.push(allPData[ap]);
        }
      });

      sortedData = sortedData.concat(unSelectedData);

      // // console.log(sortedData);
      return sortedData;
    },
    personalityTraitSelected(id) {
      if (this.localPersonalityData.personalityTraitsGala) {
        let arrOfIds = [];
        this.localPersonalityData.personalityTraitsGala.forEach((sd) => {
          arrOfIds.push(sd.id);
        });
        return arrOfIds.includes(id);
      } else {
        return false;
      }
    },
    pushPersonality(id, index) {
      if (!this.isUserLoggedIn || this.internetConnectionStatus) return;

      if (this.most6Set && this.getPersonalityTraitById(id).priorityNumber > 0)
        return;

      if (!this.localPersonalityData.personalityTraitsGala) {
        this.localPersonalityData.personalityTraitsGala = [];
      }
      const pIndex = this.localPersonalityData.personalityTraitsGala.findIndex(
        (pI) => pI.id === id
      );

      // best, most & least not selected
      if (!this.most6Set) {
        if (pIndex === -1) {
          this.localPersonalityData.personalityTraitsGala.push({ id });

          // Set personality statements


          // Best 6 selected
          if (this.localPersonalityData.personalityTraitsGala.length === 6) {
            if (this.localPersonalityData.personalityTraitsGala.length < 7) {
              const self = this;
              self.localPersonalityData.personalityStatementsGala = "";
              this.localPersonalityData.personalityTraitsGala.forEach((pt) => {
                self.localPersonalityData.personalityStatementsGala +=
                  self.getPersonalityTraitById(pt.id).iAmDescription + "\n";
                //  Personality  youLabMap Id
                this.personalityId.push(
                  self.getPersonalityTraitById(pt.id).personalityMapId
                );
              });
              this.personalityYoulabData = [...new Set(this.personalityId)];
              for(let n = 37; n <= 54; n++) {
                this.answers[n]=0;
              }
              console.log('this.answers',this.answers);
              if (this.personalityYoulabData.length === 6) {
                for (let i = 37; i <= 54; i++) {
                  for (let j = 0; j < this.personalityYoulabData.length; j++) {
                    if (i === this.personalityYoulabData[j]) {
                      this.idBestData[i] = 2;
                    }
                  }
                }
                console.log('his.idBestData',this.idBestData);

                //// console.log(this.idDataAll,this.idData);

                // Object Array Merge
                // this.answers = JSON.parse(
                //   JSON.stringify(Object.assign({}, this.idDataAll, this.idData))
                // );
                // //   console.log('organizationId',this.organizationId);
                // let youlabData = "";
                // if(this.organizationIds){
                //   youlabData =
                //     {
                //       "_id": this.personality._id,
                //       "answers": this.answers,
                //       "youlabId": this.$store.state.boards.userBoardData.youlabId,
                //       "flag": "talentPrintIdSync",
                //       'youlabToken': this.$store.state.boards.userBoardData.youlabToken,
                //       'progress': this.$store.state.boards.userBoardData.progress,
                //       'board_user_id': this.$store.state.boards.userBoardData._id,
                //     }
                //   this.$store
                //     .dispatch("editor/updatePersonality",youlabData)
                //     .then(res =>{
                //       // console.log(res);
                //       this.$store
                //         .dispatch("boards/fetchUserBoardData",this.$store.state.auth.user._id ).then(res=>{
                //
                //         this.$vs.loading.close();
                //       }) .catch((err) => {
                //         throw err;
                //       })
                //     })
                //     .catch((err) => {
                //       throw err;
                //     })
                // }
              }
              this.saveField("savePersonalityStatementsGala");
            }
            this.$vs.notify({
              title: "Choose 6 more strengths",
              text: "Choose 6 more strengths (Characteristics that MOST describe you)",
              fixed: false,
            });
          }

          // Most 6 selected
          if (this.localPersonalityData.personalityTraitsGala.length === 12) {
            this.$vs.loading();
            if (this.localPersonalityData.personalityTraitsGala.length < 13) {
              const self = this;
              self.localPersonalityData.personalityStatementsGala = "";
              this.localPersonalityData.personalityTraitsGala.forEach((pt) => {
                self.localPersonalityData.personalityStatementsGala +=
                  self.getPersonalityTraitById(pt.id).iAmDescription + "\n";
                //  Personality  youLabMap Id
                this.personalityId.push(
                  self.getPersonalityTraitById(pt.id).personalityMapId
                );
              });
              this.personalityYoulabData = [...new Set(this.personalityId)];
              if (this.personalityYoulabData.length === 12) {
                for (let i = 37; i <= 54; i++) {
                  for (let j = 6; j < this.personalityYoulabData.length; j++) {
                    if (i === this.personalityYoulabData[j]) {
                      this.idMostData[i] = 1;
                    }
                  }
                }
                this.answers = JSON.parse(
                  JSON.stringify(Object.assign({}, this.answers,this.idBestData, this.idMostData))
                );
                console.log('this.idBestData', this.idBestData);
                console.log('this.idMostData', this.idMostData);
                console.log('this.answers', JSON.stringify(this.answers));


                  console.log('organizationId',this.organizationId);
                let youlabData = "";
                if(this.organizationIds){
                  youlabData =
                    {
                      "_id": this.personality._id,
                      "answers": this.answers,
                      "youlabId": this.$store.state.boards.userBoardData.youlabId,
                      "flag": "talentPrintIdSync",
                      'youlabToken': this.$store.state.boards.userBoardData.youlabToken,
                      'progress': this.$store.state.boards.userBoardData.progress,
                      'board_user_id': this.$store.state.boards.userBoardData._id,
                    }
                  this.$store
                    .dispatch("editor/updatePersonality",youlabData)
                    .then(res =>{
                      // console.log(res);
                      this.$store
                        .dispatch("boards/fetchUserBoardData",this.$store.state.auth.user._id ).then(res=>{

                        // const payload = {
                        //   title: "Your self-assessment is complete! ",
                        //   text: `This maps your best to least known abilities. Now prioritize the ones you develop and invite a few advisors for a 360 view.`,
                        //   currentThis: this,
                        // };
                        // successNotifyService(payload);
                        this.$vs.notify({
                          title:
                            "Your self-assessment is complete!",
                          text: "This maps your best to least known abilities. Now prioritize the ones you develop and invite a few advisors for a 360 view.",
                          fixed: true,
                          color:'success'
                        });

                        this.$vs.notify({
                          title:
                            "Choose the abilities you want to develop.",
                          text: "Click on the abilities and rank priority of development as per the required context.",
                          fixed: true,
                        });

                        this.$vs.loading.close();
                      }) .catch((err) => {
                        throw err;
                      })
                    })
                    .catch((err) => {
                      throw err;
                    })
                }
              }
              this.saveField("savePersonalityStatementsGala");
            }
          }
        } else {
          console.log(index);
          if (
            (index < 6 && !this.best6Set) ||
            (index >= 6 && index < 12 && !this.most6Set)
          ) {
            this.localPersonalityData.personalityTraitsGala.splice(pIndex, 1);
          }
        }
      } else {
        this.$store
          .dispatch(
            "boards/fetchUserBoardData",
            this.$store.state.auth.user._id
          )
          .then((res) => {})
          .catch((err) => {
            throw err;
          });
        if (pIndex === -1) {
          this.localPersonalityData.personalityTraitsGala.push({
            id,
            priorityNumber: this.getNextPriorityNumber(),
          });
        } else if (
          !this.localPersonalityData.personalityTraitsGala[pIndex]
            .priorityNumber
        ) {
          this.localPersonalityData.personalityTraitsGala[pIndex][
            "priorityNumber"
            ] = this.getNextPriorityNumber();
        } else {
          return;
        }
      }

      this.saveField("savePersonalityTraitsGala");
    },
    async saveField(action, fieldName = null) {
      let fieldIsValid = false;

      if (fieldName) {
        fieldIsValid = await this.$validator.validate(fieldName);

        if (!fieldIsValid) {
          return;
        }
      } else {
        fieldIsValid = true;
      }

      //// console.log(fieldIsValid);

      if (fieldName && !fieldIsValid) {
        return;
      }

      // // console.log(this.localPersonalityData);

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        action,
        localData: this.localData,
        localPersonalityData: this.localPersonalityData,
        userId: this.userId,
        currentThis: this,
      };

      saveInputFieldService(payload);
    },
    getCharacterTypeCount(ccg) {
      let count = 0;

      if (
        this.localPersonalityData.personalityTraitsGala &&
        this.localPersonalityData.personalityTraitsGala.length
      ) {
        this.localPersonalityData.personalityTraitsGala.forEach(
          (personality, index) => {
            if (
              index < 6 &&
              this.getPersonalityTraitById(personality.id).characterType ===
              ccg.slug
            ) {
              count++;
            }
          }
        );
      }

      return count ? `+${count}` : 0;
    },
    toggleCharacterType(slug, value) {
      this.characterType[slug] = value;
      this.$forceUpdate();
    },
    toggleCharacterClass(slug, value) {
      this.characterClass[slug] = value;
      this.$forceUpdate();
    },
    isCharacterTypeHovered(characterType) {
      return this.characterType[characterType];
    },
  },
  created() {
    this.$vs.loading;
    this.$store.dispatch("editor/toggleRightBar", true);
    this.$store.dispatch("editor/togglePreviewMode", false);
    this.sortedPersonalityData = this.sortPersonalityData();
    //youlabToken Set On Board Label
    this.$vs.loading.close();
    if (this.isUserLoggedIn) {
      this.$store
        .dispatch("boards/fetchUserBoardData", this.$store.state.auth.user._id)
        .then((res) => {
          if (res.data) {
            console.log(
              "res.data.boardData.organizationId;",
              res.data.data[0].boardData.organizationId
            );
            this.organizationIds = res.data.data[0].boardData.organizationId;
          }
        })
        .catch((err) => {
          throw err;
        });
      if (!this.autoLoginToken) {
        this.autoLoginToken = this.$route.params.token;
      }
      if (this.usersData && Object.keys(this.usersData).length) {
        this.localData = JSON.parse(JSON.stringify(this.usersData));
        //// console.log(this.localData);
      }
      if (this.personality && Object.keys(this.personality).length) {
        this.localPersonalityData = JSON.parse(
          JSON.stringify(this.personality)
        );
      }
    }
  },
  mounted() {
    if (
      this.$route.name.includes("editor-personality") &&
      localStorage.getItem("personalityTour") !== "finished" &&
      localStorage.getItem("personalityTour") !== "skipped"
    ) {
      // console.log(this.$tours);
      if (this.$tours["personalityTour"]) {
        this.$tours["personalityTour"].start();
      }
    }
    // if (this.isUserLoggedIn) {
    //   this.$store
    //     .dispatch("users/fetchUser", this.$store.state.auth.user._id)
    //     .then((res) => {
    //       console.log('dataasasasas',res.data);
    //       const data = {
    //         flag: "galaTalentPrintProgress",
    //         _id: res.data.personality[0]._id,
    //         user_id: res.data.personality[0].personalityYoulabId,
    //         progress: res.data.personality[0].personalityYoulabProgress,
    //       };
    //       this.$store
    //         .dispatch("editor/updatePersonality", data)
    //         .then((res) => {
    //           this.$store
    //             .dispatch("users/fetchUser", this.$store.state.auth.user._id)
    //             .then((res) => {
    //               this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
    //             })
    //             .catch();
    //         }).catch();
    //     }).catch();
    // }
  },
};
</script>

<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: calc(100vh - 6rem);
  /*height: 1000px;*/
}
.personality-unit {
  border: 1px solid #f4f4f4;
  box-sizing: border-box;
  border-radius: 6px;
}

.personality-unit:hover {
  border: 1px solid #d8d5d5;
  cursor: pointer !important;
}

.personality-unit--most {
  border-radius: 6px;
}

.personality-unit--most:hover {
  cursor: pointer !important;
}

.personality-unit--least:hover {
  cursor: pointer !important;
}

.personality-title {
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 19px;
  color: #414040;
}

.personality-order {
  background: #f29200;
  box-shadow: 0px 4px 8px rgba(255, 172, 46, 0.29);
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 50%;
  color: white;
}

.text-personality-style {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: #7c7c7c;

  flex: none;
  order: 1;
  flex-grow: 0;
}

.broadcast-personality-selected {
  color: #f29300;
}

/*.vs-con-textarea >>> .vs-textarea {
  height: 90px !important;
}*/

.moving-item {
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
}

/*.vs-con-textarea >>> .vs-textarea {
  height: auto !important;
}*/

.personality-options >>> .vs-icon {
  font-weight: 900 !important;
  font-size: 20px !important;
  /*border: none;*/
}
.iframe-container {
  height: 100vh;
}

.v-tour >>> .v-step__button.v-step__button-skip {
  display: none !important;
}

.conflict-confronter:hover {
  background: rgba(113, 64, 255, 0.1) !important;
  border: 1px solid rgba(113, 64, 255, 0.1) !important;
}

.social-networker:hover {
  background: rgba(220, 0, 50, 0.1) !important;
  border: 1px solid rgba(220, 0, 50, 0.1) !important;
}

.skilled-communicator:hover {
  background: rgba(220, 0, 47, 0.1) !important;
  border: 1px solid rgba(220, 0, 47, 0.1) !important;
}

.compassionate-carer:hover {
  background: rgba(255, 123, 145, 0.1) !important;
  border: 1px solid rgba(255, 123, 145, 0.1) !important;
}

.responsible-citizen:hover {
  background: rgba(255, 123, 145, 0.1) !important;
  border: 1px solid rgba(255, 123, 145, 0.1) !important;
}

.methodical-organizer:hover {
  background: rgba(68, 204, 136, 0.1) !important;
  border: 1px solid rgba(68, 204, 136, 0.1) !important;
}

.inspirational-motivator:hover {
  background: rgba(196, 20, 50, 0.1) !important;
  border: 1px solid rgba(196, 20, 50, 0.1) !important;
}

.calming-influence:hover {
  background: rgba(255, 123, 145, 0.1) !important;
  border: 1px solid rgba(255, 123, 145, 0.1) !important;
}

.practical-fixer:hover {
  background: rgba(68, 204, 136, 0.1) !important;
  border: 1px solid rgba(68, 204, 136, 0.1) !important;
}

.constant-learner:hover {
  background: rgba(103, 216, 243, 0.1) !important;
  border: 1px solid rgba(103, 216, 243, 0.1) !important;
}

.flexible-character:hover {
  background: rgba(68, 204, 136, 0.1) !important;
  border: 1px solid rgba(68, 204, 136, 0.1) !important;
}

.big-picture-thinker:hover {
  background: rgba(103, 216, 243, 0.1) !important;
  border: 1px solid rgba(103, 216, 243, 0.1) !important;
}

.effective-negotiator:hover {
  background: rgba(242, 147, 0, 0.1) !important;
  border: 1px solid rgba(242, 147, 0, 0.1) !important;
}

.sound-decision-maker:hover {
  background: rgba(242, 147, 0, 0.1) !important;
  border: 1px solid rgba(242, 147, 0, 0.1) !important;
}

.people-leader:hover {
  background: rgba(242, 147, 0, 0.1) !important;
  border: 1px solid rgba(242, 147, 0, 0.1) !important;
}

.willing-risk-taker:hover {
  background: rgba(113, 64, 255, 0.1) !important;
  border: 1px solid rgba(113, 64, 255, 0.1) !important;
}

.energetic-driver:hover {
  background: rgba(113, 64, 255, 0.1) !important;
  border: 1px solid rgba(113, 64, 255, 0.1) !important;
}

.imaginative-mind:hover {
  background: rgba(103, 216, 243, 0.1) !important;
  border: 1px solid rgba(103, 216, 243, 0.1) !important;
}

@media only screen and (max-width: 991px) {
  .d-character-types {
    display: none;
  }
}
</style>
